import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import { AdministrationServicePath, PREPARATORY_COURSES } from "utils/constants";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";
import ListCourses from "./List";
import CreateCourses from "./Create";
import EditCourses from "./Edit";
import ShowCourses from "./Show";

export const resources = {
  tenancies: [tenants.MU],
  isMenu: true,
  icon: <LocalLibraryIcon />,
  name: AdministrationServicePath + PREPARATORY_COURSES,
  title: "КСК курсове",
  list: <ListCourses />,
  create: <CreateCourses />,
  createPermission: permissions.canCreatePreparatoryCourses,
  edit: <EditCourses />,
  editPermission: permissions.canUpdatePreparatoryCourses,
  show: <ShowCourses />,
  showPermission: permissions.canPreviewPreparatoryCourses,
  permission: permissions.canPreviewPreparatoryCourses,
};
